<template>
  <TableBasic :payload="payload" @onChange="changeParameter" @onExport="exportToCsv">
    <template v-slot:OrderSellerID="{data, value}">
      <div>
        <router-link
          :to="`/finance/refunds/${data.OrderSellerRefundID}`"
        >
          {{ value }}
        </router-link>
      </div>
    </template>

    <template v-slot:OrderSellerRefundID="{value}">
      <span>Refund PaxelMarket {{value}}</span>
    </template>

    <template v-slot:BuyerPhone="{value}">
      <a
        :href="'https://wa.me/'+value"
        target="_blank"
        rel="noopener"
      >
        {{value}}
      </a>
    </template>

    <template v-slot:actions="{data}">
      <div v-if="data.actions.refund == 'enable'">
        <a class="btn bg-danger text-white fw-bold d-inline-block me-2" data-bs-target="#reject-modal" data-bs-toggle="modal" @click="injectRejectData(data)">
          <font-awesome-icon icon="fa-solid fa-times"/> Reject
        </a>
        <a class="btn fw-bold text-danger border-danger d-inline-block" data-bs-target="#approve-modal" data-bs-toggle="modal" @click="injectDataModal(data)">
          Refund
        </a>
      </div>
    </template>
  </TableBasic>

  <ApproveModal :payload="dataRefund"/>
  <RejectModal :payload="dataReject"/>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import ApproveModal from "@/components/modals/Approve";
import RejectModal from "@/components/modals/Reject";

export default {
  components: {
    TableBasic,
    ApproveModal,
    RejectModal
  },
  data() {
    return {
      filterValue: {},
      payload: {
          filter: true,
          filterList: [
            {
              label : 'Filter by Paid Date',
              value: "paid_date"
            },
            {
              label : 'Filter by Cancelled Date',
              value: "cancel_date"
            },
          ],
          filterLabel: "Filter by Paid Date",
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },
          header: [
            {
              key: "RefundAmount",
              label: "AMOUNT",
              style: {minWidth: '100px'},
              class: "px-3 fw-bold",
              isCurrency: true,
              sort: false,
            },
            {
              key: "OrderSellerRefundID",
              label: "DESCRIPTION",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false,
            },
            {
              key: "OrderSellerID",
              label: "C. ORDER ID",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "PaymentMethod",
              label: "PAYMENT METHOD",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "PaidAccount",
              label: "PAYMENT ACCOUNT",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "SellerStoreName",
              label: "SELLER",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "BuyerName",
              label: "BUYER",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "BuyerPhone",
              label: "BUYER PHONE",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "BuyerEmail",
              label: "BUYER EMAIL",
              style: {minWidth: '100px'},
              class: "px-3",
              sort: false
            },
            {
              key: "LatestStatus",
              label: "LATEST STATUS",
              style: {minWidth: '100px'},
              class: "px-3 fw-bold",
              sort: false
            },
            {
              key: "PaidDate",
              label: "PAID",
              style: {minWidth: '100px'},
              class: "px-3",
              sort_key : "paid_date",
              sort: true
            },
            {
              key: "CancelBy",
              label: "CANCEL BY",
              style: {minWidth: '100px'},
              class: "px-3 fw-bold",
              sort: false
            },
            {
              key: "CancelDate",
              label: "CANCELLED",
              style: {minWidth: '100px'},
              class: "px-3",
              sort_key : "cancel_date",
              sort: true
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-center",
            }
          ],
          value: [],
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 20, 50, 100],
          search: true,
          searchInput : "",
          start_date: "",
          end_date: "",
          searchPlaceholder: "Search C. Order ID/Seller Name/Buyer Name/Buyer Phone No",
          sortType : -1,
          sortBy : "" ,
          filterValue : {},
          filterBy: "",
          export: true,
          exportOptions:{
            disabled: true,
            hidden: true
          }
        },
      dataRefund: {
        formLabel: "Select Refund Date",
        titleModal: "REFUND APPROVE",
        textButton: "REFUND",
        actionPath: "refunds/approve",
        body: {
          order_seller_refund_id: '',
          approve_time: '',
        }
      },
      dataReject: {
        formLabel: "Enter rejection reason",
        titleModal: "REJECT REFUND",
        textButton: "REJECT",
        actionPath: "refunds/reject",
        body: {
          order_seller_refund_id: '',
          reason: '',
        }
      },
    };
  },
  methods: {
    async getData() {
      const payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
        status: 'PENDING',
        keyword: this.payload.keyword,
        sort_by: this.payload.sortBy,
        sort_type: this.payload.sortType,
        filter_date_by: 'paid_date'
      }

      if(this.filterValue.from) payload.start_date = this.filterValue.from
      if(this.filterValue.to) payload.end_date = this.filterValue.to
      if(this.filterValue.value) payload.filter_date_by = this.filterValue.value

      const response = await this.$store.dispatch("refunds/getAll", payload)
      if (response.data.data.items == null) {
          // await Swal.fire({
          //   icon: 'error',
          //   title: 'Oops...',
          //   text: "Data not found",
          // })
          this.payload.value = response.data.data.items
        }
        else{
          let groupdata = this.$store.getters['refunds/refundsItems']
          this.payload.value = groupdata
        }
      this.payload.totalRows = response.data.data.count
      this.countItems = response.data.data.count
    },
    async injectDataModal(data) {
      this.dataRefund.body.order_seller_refund_id = data.OrderSellerRefundID
      this.dataRefund.minDate = data.CancelDate
    },
    injectRejectData(data) {
      this.dataReject.body.order_seller_refund_id = data.OrderSellerRefundID
    },
    changeParameter(value) {
      this.payload.perPage = value.per_page
      this.payload.currentPage = value.current_page
      this.filterValue = { ...this.filterValue,...value.filter }
      this.payload.keyword = value.search
      this.payload.sortBy = value.sort_by
      this.payload.sortType = value.sort_type
      this.getData()
    },
    async exportToCsv(){
      const payload = {
        status: 'PENDING',
        page: this.payload.currentPage,
        size: this.payload.perPage,
        keyword: this.payload.keyword,
        filter_date_by: 'paid_date'
      }

      if(this.payload.sortBy) payload.sort_by = this.payload.sortBy
      if(this.payload.sortType) payload.sort_type = this.payload.sortType
      if(this.filterValue.from) payload.start_date = this.filterValue.from
      if(this.filterValue.to) payload.end_date = this.filterValue.to
      if(this.filterValue.value) payload.filter_date_by = this.filterValue.value

      try{
        const response = await this.$store.dispatch("refunds/exportCsv", payload)
        console.log(response.data.data.file)
        window.open(
           response.data.data.file,
           '_blank'
         );
      }catch(err){
        console.log({err})
        this.$swal({
          icon: "error",
          title: 'Something Went Wrong',
          text: "Failed Send Request",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
  mounted() {
    this.getData()
  },
  watch:{
    filterValue (newValue){
      if(newValue?.from && newValue?.to){
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : false, hidden: false}
      }else if(newValue?.from || newValue?.to){
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : true, hidden: false}
      }else{
        this.payload.exportOptions = {...this.payload.exportOptions, disabled : true, hidden: true}
      }
    }
  }
};
</script>

<style></style>
